import { MyBonusHistory } from './MyBonusHistory';

export default MyBonusHistory;
